import { render, staticRenderFns } from "./WidgetsInput.vue?vue&type=template&id=5d8e1a8b&scoped=true&"
import script from "./WidgetsInput.vue?vue&type=script&lang=js&"
export * from "./WidgetsInput.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsInput.vue?vue&type=style&index=0&id=5d8e1a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8e1a8b",
  null
  
)

export default component.exports